import React, { useEffect, useState } from 'react';
import Pagination from '../pagination/Pagination';
import axios from 'axios';
import { Link } from 'react-router-dom';

const NotificationMessageAndrod = () => {

    const [notification, setNotification] = useState([]);

    const [showPerPage] = useState(10);

    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage
    });

    const onChangePagination = (start, end) => {
        setPagination({
            start,
            end
        });
    };


    const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};


    // Get Android notifications
    const notification_get = async () => {

        try {

            const dist = sessionStorage.getItem("dist");

            const res = await axios.post(
                `https://lionsdirectoryapi.emedha.in/notification/api/notifications-with-image/get`,
                {
                    dist
                }
            );

            setNotification(res.data);

        } catch (error) {

            console.error(
                "Error fetching Android notifications:",
                error
            );

        }
    };

    // Delete notification
    const deleteNotify = async (id) => {

        const dist = sessionStorage.getItem("dist");

        if (window.confirm('Are you sure to delete this data...?')) {

            try {

                await axios.post(
                    `https://lionsdirectoryapi.emedha.in/notification/api/notification-with-image/delete`,
                    {
                        id,
                        dist
                    }
                );

                alert('Data deleted successfully!');

                notification_get();

            } catch (error) {

                console.error("Delete error:", error);

                alert("Failed to delete notification.");

            }
        }
    };

    useEffect(() => {
        notification_get();
    }, []);

    return (
        <>
            <div
                style={{ marginTop: '1rem' }}
                className='table-container'
            >

                <table className="styled-table table table-bordered">

                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Title</th>
                            <th>Body</th>
                            <th>Image</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody className='table-bordered'>

                        {notification
                            .slice(
                                pagination.start,
                                pagination.end
                            )
                            .map((data, index) => {

                                return (
                                    <tr key={data.id}>

                                        {/* S.No */}
                                        <td>
                                            {pagination.start + index + 1}
                                        </td>

                                        {/* Title */}
                                        <td>
                                            {data.title}
                                        </td>

                                        {/* Body */}
                                        <td>
                                            {data.body}
                                        </td>

                                        {/* Image */}
                                        <td>
                                            {data.image_url ? (

                                                <img
                                                    src={data.image_url}
                                                    alt={data.title || "Notification"}
                                                    style={{
                                                        width: '100px',
                                                        height: '70px',
                                                        objectFit: 'cover',
                                                        borderRadius: '5px'
                                                    }}
                                                />

                                            ) : (

                                                <span>
                                                    No Image
                                                </span>

                                            )}
                                        </td>

                                        {/* Created Date */}
                                      <td>
    {formatDate(data.created_at)}
</td>


                                        {/* Delete */}
                                        <td>

                                            <Link
                                                to="#"
                                                className='btn btn-danger'
                                                onClick={() =>
                                                    deleteNotify(data.id)
                                                }
                                            >
                                                Delete
                                            </Link>

                                        </td>

                                    </tr>
                                );

                            })}

                    </tbody>

                </table>

                <Pagination
                    page={showPerPage}
                    onChangePagination={onChangePagination}
                    total={notification.length}
                />

            </div>
        </>
    );
};

export default NotificationMessageAndrod;
